module.exports = {
      id: "arrow-special-usage",
      viewBox: "0 0 33 14",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#arrow-special-usage",
      toString: function () {
        return this.url;
      }
    }